import PageContainer from "../PageContainer";
import { UnitForm } from "./UnitForm";
import { useState } from "react";
import { usePreload } from "../../../contexts/DataContext/PreloadContext";
import { saveUnit } from "../../../services/unitService";
import { unitsPageCache } from "../../../pages/cache/PageCache";

const emptyRow = {};

const AddUnit = () => {
  const { showNotification } = usePreload();
  const [saving, setSaving] = useState(false);
  const onSave = async (updatedRow) => {
    if (!updatedRow.unitCode.trim()) {
      showNotification("Unit code is required", "error");
      return false;
    }

    try {
      setSaving(true);
      const response = await saveUnit(updatedRow);
      if (response instanceof Response && !response.ok)
        throw new Error("Save failed");
      unitsPageCache.clear();
      showNotification(`new unit was added!`, "success");
      return true;
    } catch (e) {
      showNotification(
        `something went wrong when adding ${updatedRow?.unitCode} unit.`,
        "error",
      );
      return false;
    } finally {
      setSaving(false);
    }
  };

  return (
    <PageContainer
      title="Create Unit"
      subtitle="Add an ETIM unit and its localized details"
      breadcrumbs={[
        { title: "ETIM Unit", path: "/unitsnew" },
        { title: "New" },
      ]}
    >
      <UnitForm
        onSave={onSave}
        props={{
          row: emptyRow,
          uploading: saving,
          saveText: "Create",
          isUpdate: false,
        }}
      />
    </PageContainer>
  );
};

export default AddUnit;
